export default {
  SET_PARENT_SECTION: "SET_PARENT_SECTION",
  RESET_PARENT_SECTION: "RESET_PARENT_SECTION",
};
